import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  informacastoutboundemailList (context, opts) {
    if (!context.state.fetchingList) {
      context.commit('INFORMACASTOUTBOUNDEMAIL_FETCHING_LIST', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/informacastoutboundemail', { params: opts })
          .then(({ data }) => {
            context.commit('INFORMACASTOUTBOUNDEMAIL_LIST', data)
            resolve(data)
          })
          .catch((error) => reject(error))
          .finally(() => context.commit('INFORMACASTOUTBOUNDEMAIL_FETCHING_LIST', false))
      })
    }
  },
  // ==========================Socket Updates==============================
  informacastoutboundemailCreated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    axios
      .get(`/api/informacastoutboundemail/${id}`, inputs)
      .then(({ data }) => {
        data.socketUpdate = true
        context.commit('INFORMACASTOUTBOUNDEMAIL_LIST_ADD', data)
      }).catch(() => {
      })
  },
  informacastoutboundemailUpdated (context, opts) {
    const current = (context.rootState.Organization.current.id === opts.organization)
    if (opts.socket && current) {
      context.commit('INFORMACASTOUTBOUNDEMAIL_SOCKET_UPDATE', new Date())
    } else {
      const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
      const inputs = { }
      if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
        inputs.params = { }
        inputs.params.populate = opts.populate
      }
      const inList = context.state.list.find((i) => i.id === id)
      if (context.state.current.id === id || inList) {
        axios
          .get(`/api/informacastoutboundemail/${id}`, inputs)
          .then(({ data }) => {
            if (data.id === context.state.current.id) {
              context.commit('INFORMACASTOUTBOUNDEMAIL_CURRENT', data)
            }
            if (inList) {
              context.commit('INFORMACASTOUTBOUNDEMAIL_LIST_UPDATE', data)
            }
          }).catch(() => {
          })
      }
    }
  },
  informacastoutboundemailDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('INFORMACASTOUTBOUNDEMAIL_CURRENT', null)
    }
    context.commit('INFORMACASTOUTBOUNDEMAIL_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  informacastoutboundemailDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/informacastoutboundemail/${id}`, inputs)
        .then(({ data }) => {
          context.commit('INFORMACASTOUTBOUNDEMAIL_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  informacastoutboundemailUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if ((updates[key] === null || updates[key] === context.state.current[key]) && key !== 'id') {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/informacastoutboundemail/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  bulkUpdateInformacastOutboundEmails (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/informacastoutboundemail/bulkupdate', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
